module.exports = __webpack_public_path__ + "static/media/logo-invterter-active.a1ed84e5.svg";